import {CLASS_MAP_BY_COLOR, CLASS_MAP_BY_STATUS_TYPE, STATUS_TYPE_CLASS_MAP_BY_COLOR, WorkflowStatusType} from './constants'

export function getColorClassById(id) {
    return CLASS_MAP_BY_COLOR[id]
}

export function getStatusClassByType(type) {
    return CLASS_MAP_BY_STATUS_TYPE[type]
}

export function getStatusTypeClassByColorId(id) {
    return STATUS_TYPE_CLASS_MAP_BY_COLOR[id]
}

export function workflowStatusComparator(st1, st2) {
    return st1.position - st2.position
}

export function workflowStatusComparatorWithStatusType(s1, s2) {
    if (s1.type === WorkflowStatusType.OPEN && s2.type === WorkflowStatusType.COMPLETED) {
        return -1
    } else if (s2.type === WorkflowStatusType.OPEN && s1.type === WorkflowStatusType.COMPLETED) {
        return 1
    } else {
        return s1.position - s2.position
    }
}



// WEBPACK FOOTER //
// ./web/js/workflowStatus/utils.js